var exports = {
  "kL": "xe7b6e3d6--5a06d9--container",
  "wm": "xe7b6e3d6--5a06d9--logo",
  "yr": "xe7b6e3d6--5a06d9--logo-image",
  "ot": "xe7b6e3d6--5a06d9--logo-icon",
  "Qs": "xe7b6e3d6--5a06d9--content",
  "md": "xe7b6e3d6--5a06d9--nowrap-text",
};

module.exports = exports;
